import type { SearchProductsItem } from '@yescapa-dev/ysc-api-js/legacy'
import type { AppCamperSearch } from '@yescapa-dev/ysc-api-js/modern'

export const useGetSearchCamperDisplayPrice = () => {
  const { n } = useI18n()
  const { map: currencyReferentialMap } = useReferentialMap('currency')

  const getSearchCamperDisplayPrice = (camper: SearchProductsItem | AppCamperSearch) => {
    if (camper.final_booking_price) {
      return n(camper.final_booking_price, {
        ...currencyReferentialMap.value[camper.final_booking_price_currency],
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    }
    else if (camper.original_booking_price) {
      return n(camper.original_booking_price, {
        ...currencyReferentialMap.value[camper.original_booking_price_currency],
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    }
    else if (camper.price_per_day) {
      return n(camper.price_per_day, {
        ...currencyReferentialMap.value[camper.price_per_day_currency],
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    }

    return
  }

  return { getSearchCamperDisplayPrice }
}
